import moment from 'moment';

export const transformSupplierShareResponse = (supplierShareDetails) => {

	let supplierSharePayload = {};
	supplierSharePayload.value = supplierShareDetails.marketShare;
	supplierSharePayload.ref_bps_change =
		supplierShareDetails.marketShareRefBpsChng;
	supplierSharePayload.ly_bps_change =
		supplierShareDetails.marketShareLYBpsChng;
	supplierSharePayload.hierarchy_validation =
		supplierShareDetails.hierarchyValidationStatus;

	let tranformWeeklyDetail = supplierShareDetails.weeklyDetails['edges'].map(
		(weeklyDetail) => ({
			current_week: weeklyDetail.node.currentWk,
			previous_week: weeklyDetail.node.previousWk,
			ly_current_week: weeklyDetail.node.currentWkLY,
			current_percentage: weeklyDetail.node.slctdMarketShr,
			previous_percentage: weeklyDetail.node.refMarketShr,
			ly_current_percentage: weeklyDetail.node.marketShareLY,
			selected_market_share: weeklyDetail.node.slctdMarketShr,
			current_duration:
				moment(weeklyDetail.node.currentWkStartDt).format('MM/DD, YYYY') +
				' - ' +
				moment(weeklyDetail.node.currentWkEndDt).format('MM/DD, YYYY'),
			previous_duration:
				moment(weeklyDetail.node.previousWkStartDt).format('MM/DD, YYYY') +
				' - ' +
				moment(weeklyDetail.node.previousWkEndDt).format('MM/DD, YYYY'),
			ly_current_duration:
				moment(weeklyDetail.node.wkStartDtLY).format('MM/DD, YYYY') +
				' - ' +
				moment(weeklyDetail.node.wkEndDtLY).format('MM/DD, YYYY'),
			bps_change_ref: weeklyDetail.node.refBpsChng,
			bps_change_ly: weeklyDetail.node.bpsChngLY,
		})
	);
	supplierSharePayload.details = tranformWeeklyDetail;
    
	return supplierSharePayload;
};